import { useEffect, useState } from 'react';
import { ProjectInterface } from '../../interfaces/Interfaces';
import ListApi from '../../api/genericApis/List.api';
import { Link } from 'react-router-dom';
import { EditProjectRoute, routes } from '../../consts/consts';
import { ModuleType } from '../../api/modules.types';
import FilterAndSearch from '../shared/FilterAndSearch';
import ServiceCard from '../shared/card/ServiceCard';
import ServiceCardSkeleton from './ServiceCardSkeleton';

export default function ProjectsTable() {
  const [list, setList] = useState<ProjectInterface[]>([]);
  const [filteredList, setFilteredList] = useState<ProjectInterface[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [activeFilter, setActiveFilter] = useState<
    'all' | 'active' | 'inactive'
  >('all');
  const [searchQuery, setSearchQuery] = useState<string>('');

  const getList = async () => {
    setLoading(true);
    await ListApi({ moduleType: ModuleType.projects })
      .then((response) => {
        setList(response.data);
        setFilteredList(response.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    let filtered = list;
    if (activeFilter !== 'all') {
      filtered = filtered.filter(
        (item) =>
          (activeFilter === 'active' && item.projectStatus === 1) ||
          (activeFilter === 'inactive' && item.projectStatus === 0),
      );
    }

    if (searchQuery) {
      filtered = filtered.filter(
        (item) =>
          item.projectTitleEn
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          item.projectDescriptionEn
            .toLowerCase()
            .includes(searchQuery.toLowerCase()),
      );
    }

    setFilteredList(filtered);
  }, [activeFilter, searchQuery, list]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h3>Completed Projects List</h3>
        <Link to={routes.addProject} className="btn btn-primary">
          Add Project
        </Link>
      </div>

      <FilterAndSearch
        activeFilter={activeFilter}
        searchQuery={searchQuery}
        onFilterChange={setActiveFilter}
        onSearchChange={setSearchQuery}
      />

      <div className="row">
        {loading && <ServiceCardSkeleton />}
        {!loading && filteredList && filteredList.length > 0 ? (
          filteredList.map((item, index) => (
            <ServiceCard
              key={index}
              title={item.projectTitleEn}
              city={item.projectLocationEn}
              imageUrl={item.projectImageUrl}
              status={item.projectStatus === 1}
              editRoute={EditProjectRoute(item.projectId)}
              moduleType={ModuleType.project}
              id={item.projectId}
              getList={getList}
            />
          ))
        ) : (
          <p>No projects found</p>
        )}
      </div>
    </div>
  );
}
